module.exports = __webpack_public_path__ + "ad4b02029cc7cdd706d1a1de456a0196.pdf";